// extracted by mini-css-extract-plugin
module.exports = {"banner":"az_Xbb","overrideMainBody":"az_Ybb","defaultBodyText":"az_Zbb"};